<template>
  <!-- Diálogo genérico para EpcModalWrapper (modo imperativo). El wrapper aporta
       header (título + cerrar); aquí: icono centrado (color por `tone`) + mensaje +
       N botones (`actions`). No asume confirmar/cancelar: cada acción emite
       `epc-action(key)` y, por defecto, cierra. Reutilizable para confirmaciones y
       cualquier otro flujo (1, 2 o 3 acciones). Solo Tailwind, colores en hex. -->
  <div>
    <div class="flex flex-col items-center text-center gap-3">
      <span class="w-20 h-20 rounded-full flex items-center justify-center" :class="iconWrapClass">
        <b-icon pack="fas" :icon="icon" custom-size="fa-3x" />
      </span>
      <p v-if="message" class="text-sm text-gray-700 leading-snug">{{ message }}</p>
      <slot></slot>
    </div>

    <div class="flex justify-center gap-3 mt-6">
      <button
        v-for="a in actions"
        :key="a.key"
        type="button"
        class="px-5 py-2 rounded-lg text-sm font-medium transition-colors"
        :class="_BtnClass(a.variant)"
        @click="_OnAction(a.key)">
        {{ a.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "WidgetDialog",

  props: {
    // Color del icono: 'info'/'brand' | 'success' | 'warning' | 'danger'/'error'.
    tone: { type: String, default: "brand" },
    icon: { type: String, default: "circle-question" },
    message: { type: String, default: "" },
    // Botones: [{ key, label, variant? }]. variant: 'primary' (azul, default) | 'ghost' | 'danger'.
    actions: { type: Array, default: () => [] },
    // Si true, al pulsar una acción el diálogo se cierra (emite close).
    closeOnAction: { type: Boolean, default: true },
  },

  computed: {
    iconWrapClass() {
      switch (this.tone) {
        case 'danger':
        case 'error':   return 'bg-[#fde8e8] text-[#e02424]'
        case 'success': return 'bg-[#def7ec] text-[#0e9f6e]'
        case 'warning': return 'bg-[#fdf6b2] text-[#c27803]'
        default:        return 'bg-[#eef3fb] text-[#3a6bc8]' // info / brand
      }
    },
  },

  methods: {
    _BtnClass(variant) {
      if (variant === 'ghost')  return 'text-gray-600 bg-white border border-[#e9e9ef] hover:bg-[#f2f2f7]'
      if (variant === 'danger') return 'text-white bg-[#e02424] hover:bg-[#c81e1e]'
      return 'text-white bg-[#3a6bc8] hover:bg-[#2f5aad]' // primary (azul de marca)
    },

    _OnAction(key) {
      this.$emit('epc-action', key)
      if (this.closeOnAction) this.$emit('close')
    },
  },
}
</script>
